export default __webpack_public_path__ + "static/media/sensotrend_connect_open_downloaded.048e8488.png";